import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Team } from "../../models/teamModel";
import { TeamHeader } from "./TeamHeader";
import { MemberRow } from "./TeamMemberRow";
import { Text } from "../../components/catalyst/text";
import { classNames } from "../../utils/appUtils";

interface TeamsTableProps {
  teams: Team[];
  setSearch: (search: string) => void;
  searchText: string;
  showSearch?: boolean;
  showMembers?: boolean;
}

interface TeamViewProps {
  team: Team;
  showMembers?: boolean;
}
const TeamView: React.FC<TeamViewProps> = ({ team, showMembers = true }) => {
  let playerNum = 0;
  return (
    <div
      className="bg-white dark:bg-gray-800 shadow rounded mb-5 flex flex-col h-full"
    >
      <TeamHeader team={team} />

      {showMembers &&
        team.members &&
        team.members.map((member, index) => (
          <div
            key={member.id}
            className={classNames(
              index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : "",
              "flex items-center"
            )}
          >
            {member.isPlayer && (
              <Text className="p-2 text-sm font-medium">{++playerNum}.</Text>
            )}
            <div className="flex-1">
              <MemberRow member={member} />
            </div>
          </div>
        ))}
    </div>
  );
};

const TeamsCollectionView: React.FC<TeamsTableProps> = ({
  teams,
  setSearch,
  searchText,
  showSearch = true,
  showMembers = true,
}) => {
  return (
    <>
      {showSearch && (
        <div className="relative flex flex-1 h-8 mt-5">
          <label htmlFor="search-field" className="sr-only">
            Search
          </label>
          <MagnifyingGlassIcon
            aria-hidden="true"
            className="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-gray-400 dark:text-gray-200"
          />
          <input
            id="search-field"
            name="search"
            type="search"
            placeholder="Search teams..."
            onChange={(e) => setSearch(e.target.value)}
            className="block h-full w-full border-0 py-0 pl-8 pr-0 text-gray-900 dark:text-gray-200 dark:placeholder:text-gray-200 bg-white dark:bg-gray-600 placeholder:text-gray-400 focus:ring-0 sm:text-sm rounded-md"
          />
        </div>
      )}
      {teams && teams.length >= 0 && (
        <div
          className={classNames(
            "grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xlg:grid-cols-4 ",
            showSearch ? "gap-5 mt-5" : "gap-2 mt-1"
          )}
        >
          {teams &&
            teams.map((team) => (
              <TeamView team={team} key={team.id} showMembers={showMembers} />
            ))}
        </div>
      )}
      {(!teams || teams.length === 0) && (
        <div className="flex flex-col items-center justify-center mt-10">
          <Text>
            {searchText
              ? `No teams found for "${searchText}".`
              : "There are no approved teams to show."}
          </Text>
        </div>
      )}
    </>
  );
};

export default TeamsCollectionView;
